/**
 * Yes, this is identical to the R4 Client, *but*
 * originally started out as a separate app from R4.
 * Keeping it coded that way in case we ever need to move
 * it out to it's own endpoint due to load, memsize, etc...
 */
import axios from 'axios'
import store from '@/store'
import useLogger from '@/composables/useLogger'

const logger = useLogger('queryBuilder')

const R = require('ramda')

const queryBuilderAuth = config => {
  return store.dispatch('getCurrentUser')
    .then((user) => {
      const idToken = user.tokens.IdToken
      config.headers.Authorization = `Bearer token="${idToken}"`
      return Promise.resolve(config)
    })
    .catch((error) => {
      logger.trace(error)
      return Promise.resolve(config) // if error, don't decorate and let it fail
    })
}

const queryBuilderAuthErrorHandler = error => {
  return Promise.reject(error)
}

const queryBuilderClient = (authRequired = true) => {
  const client = axios.create({
    baseURL: process.env.VUE_APP_QUERY_BUILDER_ENDPOINT
  })
  if (authRequired) {
    client.interceptors.request.use(queryBuilderAuth, queryBuilderAuthErrorHandler)
  }
  return client
}

export function queryBuilderError (axiosError) {
  const msg = R.pathOr(axiosError.message, ['response', 'data', 'data', 'message'], axiosError)
  const statusCode = R.pathOr('???', ['response', 'status'], axiosError)
  const error = new Error(msg)
  error.status = statusCode
  return error
}

export default queryBuilderClient
